import PlayersDataTable from './PlayersDataTable';

export default PlayersDataTable;
